var _defs, _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ce6eac;\n        stroke-width: 2.5px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #ce6eac;\n      }\n\n      .cls-3 {\n        opacity: .2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 65,
    cy: 65.18,
    r: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.23,
    y: 28.43,
    width: 49.54,
    height: 13.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.65 14.63 71.35 14.63 74.19 28.43 55.81 28.43 58.65 14.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65 62.91 28.25 65.93 39.59 112.94 90.41 112.94 101.75 65.93 65 62.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.08 65.37 35.08 42.05 94.92 42.05 94.92 65.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.01,
    y1: 49.33,
    x2: 65.01,
    y2: 71.73
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.19,
    y1: 27.7,
    x2: 87.79,
    y2: 41.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65,
    y1: 28.65,
    x2: 78.34,
    y2: 41.99
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.5,95.17c0,3.03,1.54,4.55,4.63,4.55s4.63-1.52,4.63-4.55v-17.33h5.28v17.21c0,3.19-.82,5.53-2.47,7.02s-4.12,2.24-7.44,2.24-5.79-.75-7.44-2.24-2.47-3.83-2.47-7.02v-17.21h5.28v17.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.bba1809805c212b06cdc771a1cd34ec6.svg";
export { ForwardRef as ReactComponent };